import gql from 'graphql-tag'

export const GET_ORGANIZER_PAYOUTS = gql`
  query getOrganizerPayouts($organizationSlug: String!) {
    getOrganizerPayouts(organizationSlug: $organizationSlug) {
      id
      eventId
      organizationId
      status
      periodFrom
      periodTo
      periodLabel
      netAmount
      grossAmount
      vatRate
      minimaxInvoiceNumber
      minimaxInvoicePdfUrl
      issuedAt
      createdAt
      requestId
      metadata
      event {
        id
        title
      }
    }
  }
`

export const GET_ALL_ORGANIZER_PAYOUTS = gql`
  query getAllOrganizerPayouts($filter: OrganizerPayoutsFilterInput) {
    getAllOrganizerPayouts(filter: $filter) {
      id
      status
      periodFrom
      periodTo
      periodLabel
      netAmount
      grossAmount
      vatRate
      minimaxInvoiceNumber
      minimaxInvoicePdfUrl
      issuedAt
      createdAt
      requestId
      metadata
      organization {
        id
        legalName
        email
        type
        slug
      }
      event {
        id
        title
        eventTemplate {
          id
          title
        }
      }
    }
  }
`

export const GET_ALL_ORGANIZER_PAYOUTS_PAGE = gql`
  query getAllOrganizerPayoutsPage($filter: OrganizerPayoutsFilterInput, $offset: Int, $limit: Int) {
    getAllOrganizerPayoutsPage(filter: $filter, offset: $offset, limit: $limit) {
      totalCount
      items {
        id
        status
        periodFrom
        periodTo
        periodLabel
        netAmount
        grossAmount
        vatRate
        minimaxInvoiceNumber
        minimaxInvoicePdfUrl
        issuedAt
        paidAt
        createdAt
        requestId
        metadata
        organization {
          id
          legalName
          email
          type
          slug
        }
        event {
          id
          title
          eventTemplate {
            id
            title
          }
        }
      }
    }
  }
`

export const GET_SETTLEMENT_EVENTS = gql`
  query getSettlementEvents($fromDate: String!, $toDate: String!, $onlyOpen: Boolean, $view: String, $offset: Int, $limit: Int, $asOf: DateTime, $population: String) {
    getSettlementEvents(fromDate: $fromDate, toDate: $toDate, onlyOpen: $onlyOpen, view: $view, offset: $offset, limit: $limit, asOf: $asOf, population: $population) {
      totalCount
      hasMore
      asOf
      items {
        eventId title from to organizationId legalName organizationType vatObligor vatPercentage
        payoutCount issuedPayoutCount paidPayoutCount pendingPayoutCount failedPayoutCount applicablePayoutIds
        latestPayoutId latestPayoutStatus latestPayoutInvoiceNumber latestPayoutPaidAt
        settlementStatus settlementNote settlementUpdatedAt settlementVersion settlementConflict
      }
    }
  }
`

export const SET_ORGANIZER_PAYOUT_PAID = gql`
  mutation setOrganizerPayoutPaid($id: Int!, $paid: Boolean!) {
    setOrganizerPayoutPaid(id: $id, paid: $paid) { id status paidAt }
  }
`

export const SET_EVENT_SETTLEMENT_STATUS = gql`
  mutation setEventSettlementStatus($eventId: Int!, $status: EventSettlementStatusType, $note: String, $expectedVersion: Int!, $reason: String) {
    setEventSettlementStatus(eventId: $eventId, status: $status, note: $note, expectedVersion: $expectedVersion, reason: $reason) {
      id eventId status note updatedAt version
    }
  }
`

export const GET_SETTLEMENT_HISTORY = gql`
  query getSettlementHistory($eventId: Int, $payoutId: Int, $limit: Int) {
    getSettlementHistory(eventId: $eventId, payoutId: $payoutId, limit: $limit) {
      id eventId payoutId action beforeState afterState actorUserId actorName reason createdAt
    }
  }
`
